import * as yup from 'yup'

const schemaQuestionnaire = () =>
  yup.object().shape({
    name: yup.string(),
    visible: yup.string().required(),
  })

export default schemaQuestionnaire
